export default "__VITE_ASSET__CXFUfTBz__"